import { render, staticRenderFns } from "./EventPopupEntryResultModal.vue?vue&type=template&id=06dae7d4&scoped=true&"
import script from "./EventPopupEntryResultModal.vue?vue&type=script&lang=ts&"
export * from "./EventPopupEntryResultModal.vue?vue&type=script&lang=ts&"
import style0 from "./EventPopupEntryResultModal.vue?vue&type=style&index=0&id=06dae7d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dae7d4",
  null
  
)

export default component.exports